export default {
  ALLOWED: `ALLOWED`,
  RESTRICTED: `RESTRICTED`,
};
